import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { TopicAnalysisRequest, TopicAnalysisResponse, TopicAnalysisState } from '../../types';
import { topicAnalysisService } from '../../services/topicAnalysisApi';

// Initial state
const initialState: TopicAnalysisState = {
  analysis: null,
  isLoading: false,
  error: null,
};

// Async thunk for analyzing a topic
export const analyzeTopic = createAsyncThunk(
  'topicAnalysis/analyzeTopic',
  async (request: TopicAnalysisRequest, { rejectWithValue }) => {
    try {
      const response = await topicAnalysisService.analyzeTopic(request);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to analyze topic');
    }
  }
);

// Topic analysis slice
const topicAnalysisSlice = createSlice({
  name: 'topicAnalysis',
  initialState,
  reducers: {
    clearAnalysis: (state) => {
      state.analysis = null;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Analyze topic
      .addCase(analyzeTopic.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(analyzeTopic.fulfilled, (state, action: PayloadAction<TopicAnalysisResponse>) => {
        state.isLoading = false;
        state.analysis = action.payload;
        state.error = null;
      })
      .addCase(analyzeTopic.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearAnalysis, clearError } = topicAnalysisSlice.actions;
export default topicAnalysisSlice.reducer;
